// extracted by mini-css-extract-plugin
export var orderDetails = "_oh-2";
export var orderImage = "_oh-1";
export var orderMeta = "_oh-3";
export var orderSummary = "_oh-0";
export var rightArrow = "_oh-4";